import { render, staticRenderFns } from "./DialogWarning.vue?vue&type=template&id=363d5830&scoped=true"
import script from "./DialogWarning.vue?vue&type=script&lang=js"
export * from "./DialogWarning.vue?vue&type=script&lang=js"
import style0 from "./DialogWarning.vue?vue&type=style&index=0&id=363d5830&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "363d5830",
  null
  
)

export default component.exports